import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import * as Page from '../../lib/page';

const WEBTOPICTREE = '/smarthelp/web-topic-tree';

function requestTopicTree() {
  return {
    type: types.REQUEST_TOPIC_TREE,
    payload: undefined,
  };
}


function receiveTopicTree(response, experience) {
  const topics = _get(response, 'webTopicTree');
  return {
    type: types.RESPONSE_TOPIC_TREE,
    payload: {
      topics,
      experience,
    },
  };
}
function receiveTopicTreeError() {
  return {
    type: types.ERROR_TOPIC_TREE,
    payload: undefined,
  };
}

export default function fetchTopicTree(experience) {
  return (dispatch) => {
    dispatch(requestTopicTree());
    return axios.get(Page.setChannelForTechnicalExp(WEBTOPICTREE))
      .then(response => dispatch(receiveTopicTree(response.data, experience)))
      .catch(() => {
        dispatch(receiveTopicTreeError());
      });
  };
}
